import React from 'react';
import { Grid, Typography, TypographyProps, styled, Stack } from '@mui/material';
import { Email, Textsms } from '@mui/icons-material';
import { phone as phoneFormatter } from '../../../../util/formatters';
import { CardOnFileCell } from '../../../../common/Customers/CardOnFileCell';
import { Customer, PaymentMethod } from '../../../../store/modules/mit/types';
import { SectionDescription } from '../MITDetails/SectionDescription';

type StyledTypography = React.ComponentType<TypographyProps<'span', { component?: 'span' }>>;
const SectionTitle: StyledTypography = styled(Typography)({
  fontSize: 12,
  color: 'grey.600',
  fontWeight: 600,
});

export const CustomerSummary = ({
  customer,
  paymentMethod,
}: {
  customer: Customer;
  paymentMethod: PaymentMethod;
}) => {
  const renderCardInfo = () => {
    const networkType = paymentMethod?.details?.networkType;
    const lastFour = paymentMethod?.details?.lastFour;
    const cardArtUrl = paymentMethod?.details?.cardArtUrl;

    return <CardOnFileCell networkType={networkType} lastFour={lastFour} cardArtUrl={cardArtUrl} />;
  };

  const renderCustomerInfo = () => {
    if (!customer) {
      return <SectionDescription>N/A</SectionDescription>;
    }

    const fullName = `${customer.firstName} ${customer.lastName}`.trim();
    const { email, phone } = customer;

    return (
      <Stack spacing={0.5}>
        {fullName && <SectionDescription>{fullName}</SectionDescription>}
        {email && (
          <SectionDescription startIcon={<Email />} sx={{ lineBreak: 'anywhere', fontSize: 12 }}>
            {email}
          </SectionDescription>
        )}
        {phone && (
          <SectionDescription startIcon={<Textsms />} sx={{ fontSize: 12 }}>
            {phoneFormatter(phone)}
          </SectionDescription>
        )}
      </Stack>
    );
  };

  return (
    <Grid container rowGap={1.5}>
      <Grid item xs={12} md={6}>
        <SectionTitle>Customer</SectionTitle>
        {renderCustomerInfo()}
      </Grid>
      <Grid item xs={12} md={6}>
        <SectionTitle sx={{ mb: 0.5 }}>Card on File</SectionTitle>
        {renderCardInfo()}
      </Grid>
    </Grid>
  );
};
